/* eslint-disable @typescript-eslint/no-this-alias */
export class TimersManager {
  protected timers: Map<string, NodeJS.Timeout> = new Map();

  public getCountTimers() {
    return this.timers.size;
  }

  public reloadTimer(
    name: string,
    ms: number | null | undefined,
    callback: () => void,
  ) {
    if (ms || ms === null) {
      // null do jawnego wyłączania timera
      this.clearTimer(name);
      this.setTimer(name, ms, callback);
    }
  }

  public setTimer(
    name: string,
    ms: number | null | undefined,
    callback: () => void,
  ) {
    const that = this;
    const safeCallback = (n: string, cal: () => void) => {
      return () => {
        const ref = that.timers.get(n);
        // zabezpieczenie przed uruchomieniem usuniętego timera - mogło się zdarzyć, że dwa razy pod jedną nazwą poszedł timer
        if (ref && cal) {
          cal();
        }
      };
    };

    if (ms) {
      const ref = setTimeout(safeCallback(name, callback), ms);
      this.timers.set(name, ref);
    }
  }

  public clearTimer(name: string) {
    const ref = this.timers.get(name);
    if (ref) {
      this.timers.delete(name);
      clearTimeout(ref);
    }
  }

  public clearAllTimers() {
    for (const [name, ref] of this.timers) {
      this.timers.delete(name);
      clearTimeout(ref);
    }
  }

  public getRef(name: string) {
    return this.timers.get(name);
  }
}
